import * as Sentry from '@sentry/browser';
import { closeSvgIconString } from './constants';

function onAdBreakstart(player) {
  const parentContainer = player.getContainer().parentElement.parentElement;
  parentContainer.classList.add('jw-ad-active');
}

function onAdBreakEnd(player) {
  const parentContainer = player.getContainer().parentElement.parentElement;
  parentContainer.classList.remove('jw-ad-active');
}

function onPlay(player) {
  const parentContainer = player.getContainer().parentElement.parentElement;
  parentContainer.classList.add('jw-playing');
}
function trackCTP(mediaID) {
  if (window.cts && window.cts.send && typeof window.cts.send.event === 'function') {
    window.cts.send.event('action', 'click', `ctp-video|${mediaID}`);
  } else {
    console.warn('CTP video tracking: CTS is not loaded');
  }
}
/**
 *
 * @param {*} player
 * @param {*} mediaID
 */
export function attachEventHandlers(player, mediaID) {
  //These error codes are to be ignored
  //900 - This error is sent when someone is trying set us ads with an old standard
  //402- related to IMASDK and timeout
  //403 - when a advertiser is trying to run a unsuppported video file, like webm or flash
  //301 - Ad request Timeout
  const IGNORE_AD_ERROR_CODES = [402, 303, 901, 900, 400, 403, 301];
  player
    .on('adError', (error) => {
      // Do not record sentry errors for these codes.
      if (error && !IGNORE_AD_ERROR_CODES.includes(error.code)) {
        Sentry.captureMessage('Ad Error', {
          tags: {
            code: JSON.stringify(error.code),
            message: JSON.stringify(error.message),
            tag: JSON.stringify(error.tag),
          },
        });
      }
    })
    .on('error', (error) => {
      const ignoredErrorCodes = [
        224003, // Media format not supported by browser
        303213, // Play attempt interrupted by pause call
        101102, // Failed to load jwplayer.core.controls component
      ];
      if (error && !ignoredErrorCodes.includes(error.code)) {
        Sentry.captureMessage('Error in the Video playback process', {
          code: JSON.stringify(error.code),
          message: JSON.stringify(error.message),
          sourceError: JSON.stringify(error.sourceError),
        });
      }
    })
    .on('play', ({ playReason }) => {
      if (playReason === 'interaction') {
        trackCTP(mediaID);
      }
      onPlay(player);
    })
    .on('playAttemptFailed', ({ error, playReason, item }) => {
      console.log('JW playAttemptFailed', error, playReason, JSON.stringify(item));
    })
    .on('adBreakStart', () => {
      onAdBreakstart(player);
    })
    .on('adBreakEnd', () => {
      onAdBreakEnd(player);
    });
}

/* Adds our own custom close button
 *
 * @param {Element} originalBtn - The original close button
 * @param {Element} parent - jwplayer player instance
 * @returns {void}
 */
export function attachCustomCloseButton(originalBtn, player) {
  const btn = document.createElement('button');
  btn.className = 'jw-custom-closeButton jw-float-icon jw-icon jw-button-color jw-reset';
  btn.innerHTML = closeSvgIconString;
  btn.setAttribute('aria-label', 'Stäng');
  btn.tabIndex = 0;
  const parent = originalBtn.parentElement.parentElement;
  const el = parent.appendChild(btn);

  // eslint-disable-next-line no-param-reassign
  originalBtn.style.display = 'none';

  el.addEventListener('click', (e) => {
    e.preventDefault();
    player.setFloating(false);
  });
}
